//////////////////////////////////////////////
//! UIVIEW 
//////////////////////////////////////////////
UIView = function(dispatcher) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------
	
//--------------------------------------------
//! Vars
//--------------------------------------------
	

	this.xDown = null;                                                        
	this.yDown = null;                                                        
	this.dispatcher = dispatcher;
	this.termsOpen = false;
	this.termsAuto = true;
	this.tracking = localisation.site.tracking.actions;

//////////////////////////////////////////////
	this.init();
//////////////////////////////////////////////

};

UIView.prototype = {


	constructor: UIView,
    
    /*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function(){

		this.initTrailer();
		this.bindEvents();
		//this.removeSubPix();
	},

    /*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/

	onShowExtraContent : function( event, data ){
		this.contentPopup( true, "linkkkkk" );
	},

	onExContentClose : function(event){

		event.preventDefault();
		this.dispatcher.dispatch( EVENTS.CLOSE_OVERLAY );
		this.dispatcher.dispatch( EVENTS.SHOW_EXPLORE );
		this.contentPopup(false);
		this.dispatcher.dispatch( EVENTS.TAB_SOUND );
	},

	onTrailerState : function(playerStatus){
		// Check for Pause and End Events
		if ( ( playerStatus.data === 0 ) || (playerStatus.data === 2))  {
			this.hideVideo();
		}

	},

	onFacebookShare : function(){
		
		//
		var data = {
			message : app.userMessage,
			type : 0
		};

		this.dispatcher.dispatch(EVENTS.SHARE_IMAGE,data);
	},

	onTwitterShare : function(){
		if(!app.downloadImage){
			$(dom.fbUpload.container).addClass("is-active");
			app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "fail" );
			return
		}
		this.dispatcher.dispatch( EVENTS.TRACKING_CLICK, this.tracking.click.twitter );
		//e.preventDefault();
		$(dom.fbUpload.container).addClass("is-active");
		$(dom.share.status_copy).html("");
		$(dom.share.status_copy).html(localisation.site.messages.uploading);
		TwitterUpload.uploadImage(app.downloadImage.src )
	},
	
	onLinkClick : function(e){
		e.preventDefault();
		var section =  $(e.currentTarget).attr('href');
			
		switch(section){
			case "#js-pg-explore" : this.dispatcher.dispatch( EVENTS.SHOW_EXPLORE ); break;
			case "explore" : this.dispatcher.dispatch( EVENTS.SHOW_EXPLORE ); break;
			case "write" :	this.dispatcher.dispatch( EVENTS.DESTROY_MESSAGE_3D); this.dispatcher.dispatch( EVENTS.HIDE_EXPLORE ); break;
			case "#js-pg-share" : this.generateSaveImage(); dom.share.status.html(""); break;
		}
		
		this.dispatcher.dispatch( EVENTS.TAB_SOUND );
		page.change( section ) ;
	},


	handleTouchStart : function ( evt ) { 
		this.yDownStart = evt.touches[ 0 ].clientY;
	},

 	handleTouchMove : function( evt ) {
		this.yDown = evt.touches[ 0 ].clientY;
 	},
	
	handleTouchEnd : function(){
		
		var diff = this.yDownStart - this.yDown ;
				
		if(diff > 160 && this.yDown !== null) {
			
			if (!this.termsOpen) {
				this.toggleCredits();
			}
			//alert();

		}
		if(diff < -20 && this.yDown !== null) {
			
			if (this.termsOpen) {
				this.toggleCredits();
			}
		}
		this.yDownStart = null;
		this.yDown = null;
	},
	
	
	checkPageClose : function(event,data){
		if( (data.previous === "recieved") || ((data.previous === "share") && (data.current === "explore") )  || ( (data.previous === "write") && (data.current === "explore") )){
			this.dispatcher.dispatch(EVENTS.DESTROY_MESSAGE_3D);
		}

	},

	onImageSavePhone : function(event){
		event.preventDefault();
		
	},

	onShareImageReady : function( event, data ) {
		if(app.downloadImage)$(app.downloadImage).remove();
		app.downloadImage = new Image();
		app.downloadImage.src = data.img;
		$(dom.share.save_img).append(app.downloadImage);
	},

	onCopyLink : function(){
		this.dispatcher.dispatch( EVENTS.TRACKING_CLICK, this.tracking.click.copyLink );
		this.dispatcher.dispatch( EVENTS.TAB_SOUND );
		$(dom.fbUpload.container).addClass("is-active");
		$(dom.share.status_copy).html( localisation.site.messages.copyLink );
	},

	onImageSaveTabStart : function(){
		this.dispatcher.dispatch( EVENTS.TRACKING_CLICK, this.tracking.click.download );
		ani.saveButton.play();
		
	},

	onImageSaveTabEnd : function(){
		ani.saveButton.seek(0).pause();
	},
	
	onTicketsClick :function(){
		this.dispatcher.dispatch( EVENTS.TRACKING_CLICKBUY, localisation.site.tracking.actions.clickBuy.tickets );
	},

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/
	bindEvents : function(){

		//SWIPE EVENTS
		window.addEventListener( 'touchstart', this.handleTouchStart.bind(this), false );
		window.addEventListener( 'touchmove', this.handleTouchMove.bind(this), false );
		window.addEventListener( 'touchend', this.handleTouchEnd.bind(this), false );

		this.dispatcher.addEventListener( EVENTS.PAGE_CLOSED, this.checkPageClose.bind( this ) );
		$(dom.exContent.close).click( this.onExContentClose.bind( this ) );

		$(dom.trailer.link).click( this.toggleTrailer.bind( this ) );
		$(dom.share.saveImg).bind('touchstart', this.onImageSaveTabStart.bind(this));
		$(dom.share.saveImg).bind('touchend', this.onImageSaveTabEnd.bind(this) );
		$(dom.share.saveImg).click( this.onImageSavePhone.bind( this ) );
		$(dom.share.facebook).click( this.onFacebookShare.bind( this ) );
		//$(dom.share.twitter).click( this.onTwitterShare.bind( this ));
		$(dom.page.link).click( this.onLinkClick.bind( this ));
		$(dom.tickets.link).click( this.onTicketsClick.bind( this ));

		$(dom.share.copyLink).click(this.onCopyLink.bind(this));
		
		$(dom.write.box).click(this.focusWrite.bind(this)); //FOCUS ON THE WRITE BOX
		
		$(dom.terms.closer).click(this.toggleCredits.bind(this));
		$('#'+dom.trailer.closeBtn).click(this.hideVideo.bind(this));

		this.dispatcher.addEventListener( EVENTS.SHARE_IMAGE_READY , this.onShareImageReady.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.SHOW_EXTRA_CONTENT, this.onShowExtraContent.bind( this ) );
		
		// var btn = document.getElementById('js-share-copyLink');
		
    		var clipboard = new Clipboard($(dom.share.copyLink)[0]);
		
    		clipboard.on('success', function(e) {
    			$(dom.share.status_copy).html( localisation.site.messages.copyLinkSuccess );
    			TweenMax.delayedCall(2,function(){
    				$(dom.fbUpload.container).removeClass( "is-active" );
    				$(dom.share.status_copy).html("" );
    			 });
    		
    		});
		
    		clipboard.on('error', function(e) {
    			$(dom.share.status_copy).html( localisation.site.messages.copyLinkError );
    			TweenMax.delayedCall(2,function(){
    		   		$(dom.fbUpload.container).removeClass( "is-active" ); 
    			});
    		});
	},

	contentPopup:function(open, content){
		
		//OPEN IT
		if (open) {
			
			//console.log($('#'+content));
			
			$(dom.exContent.wrapper).addClass('is-active');
			$('#'+content).addClass('is-current');
		
		//CLOSE IT
		} else {
			
			$(dom.exContent.wrapper).removeClass('is-active');
			$(dom.exContent.inner).removeClass('is-current');
		}
		
	},

	initTrailer : function(){
		var playsinline = 1;
		// Check for iphones and force us enative video player
		if (Detectizr.device.model == 'iphone'  ) {
			playsinline = 0;
		}
		
		//Setup YOUTUBE OBJECT
		dom.trailer.player = new YT.Player(dom.trailer.iframe, {
			height: '200',
			width: '300',
			videoId: localisation.trailer.yt_id,
			playerVars: {
				playsinline: playsinline,
				fs: 0,
				showinfo: 0,
				modestbranding: 1,
				rel: 0,
			},
			events: {
				'onStateChange': this.onTrailerState.bind(this)
			}
		});
		
	},

	toggleTrailer:function(e){
		this.dispatcher.dispatch( EVENTS.TAB_SOUND );


		this.dispatcher.dispatch( EVENTS.TRACKING_VIDEO, localisation.site.tracking.actions.video.trailer );
		// if the trailer is NOT playing
		
			//this.dispatcher.dispatch( EVENTS.TOGGLE_RENDER, { pause : true });
			TweenMax.delayedCall(1,function(){
				app.dispatcher.dispatch( EVENTS.MUTE_SOUND )
			}); 
			dom.trailer.isPlaying = true; // track play state
			dom.trailer.player.seekTo(0); // reset play position
			dom.trailer.player.playVideo(); // play it
		
			// Check NOT iphone+Safari
			if ((Detectizr.device.model != 'iphone'  )) {
				
				// Add css state to iframe
				$('#'+dom.trailer.eleId).addClass('is-active');
			}
		
	},
	
	hideVideo : function(){
		//this.dispatcher.dispatch( EVENTS.TOGGLE_RENDER, { pause : false });
		this.dispatcher.dispatch( EVENTS.UNMUTE_SOUND ); 
		//this.dispatcher.dispatch( EVENTS.TAB_SOUND );
		dom.trailer.isPlaying = false;
		dom.trailer.player.pauseVideo(); 
		if (Detectizr.device.model != 'iphone' ) {
			$('#'+dom.trailer.eleId).removeClass('is-active');
		}
	},

	focusWrite: function(){
		$(dom.write.input).focus();
		this.dispatcher.dispatch( EVENTS.TAB_SOUND );
	},
	
	toggleCredits:function(data) {
		
		if (!this.termsOpen) {
			$('.terms').addClass('is-active');
			this.termsOpen = true;
		} else {
			$('.terms').removeClass('is-active');
			this.termsOpen = false;
			this.termsAuto = false;//lock out the sutomatic terms functionality once manually closed
		}
		
	},
	
	autoCredits:function(event){
		if (!this.termsOpen) {
			this.toggleCredits();
			
			setTimeout(function(){
				if (this.termsOpen && this.termsAuto) {
					this.toggleCredits();
				}
			}.bind(this), 3000)
		}
	},
	
	


};
